import { cva as r } from "../../modules/index.es4.js";
const e = r(
  "px-4 py-2 inline-flex font-semibold items-center truncate justify-center rounded-full border disabled:opacity-50",
  {
    variants: {
      appearance: {
        gray: "bg-gray-200 border-gray-200 text-foreground dark:text-background",
        deep: "bg-deep border-deep text-white",
        primary: "bg-primary border-primary text-primary-foreground",
        secondary: "bg-secondary border-secondary text-secondary-foreground",
        tertiary: "bg-tertiary border-tertiary text-tertiary-foreground",
        success: "bg-success border-success text-gray",
        danger: "bg-danger border-danger text-white",
        warning: "bg-warning border-warning text-white",
        info: "bg-info border-info text-white",
        background: "bg-background border-background text-foreground",
        foreground: "bg-foreground border-foreground text-background"
      },
      variant: {
        default: "",
        outline: "bg-white",
        light: "",
        icon: "p-0"
      },
      size: {
        sm: "text-[12px] h-7",
        md: "text-[14px] h-8",
        xs: "text-[12px] h-6",
        xxs: "text-[10px] h-5"
      }
    },
    compoundVariants: [
      // Outline
      {
        variant: "outline",
        class: "!text-gray"
      },
      // Icon
      {
        variant: "icon",
        class: "min-w-[32px]"
      },
      {
        variant: "icon",
        size: "sm",
        class: "min-w-[28px]"
      },
      {
        variant: "icon",
        size: "xs",
        class: "min-w-[24px]"
      },
      {
        variant: "icon",
        size: "xxs",
        class: "min-w-[20px]"
      },
      // Light
      {
        variant: "light",
        appearance: "gray",
        class: "bg-gray-200/50 border-gray-200/50 !text-foreground"
      },
      {
        variant: "light",
        appearance: "deep",
        class: "bg-deep-200/50 border-deep-200/50 !text-deep"
      },
      {
        variant: "light",
        appearance: "primary",
        class: "bg-primary-200/50 border-primary-200/50 !text-primary"
      },
      {
        variant: "light",
        appearance: "secondary",
        class: "bg-secondary-200/50 border-secondary-200/50 !text-secondary"
      },
      {
        variant: "light",
        appearance: "tertiary",
        class: "bg-tertiary-200/50 border-tertiary-200/50 !text-tertiary"
      },
      {
        variant: "light",
        appearance: "success",
        class: "bg-success-200/50 border-success-200/50 !text-success"
      },
      {
        variant: "light",
        appearance: "danger",
        class: "bg-danger-200/50 border-danger-200/50 !text-danger"
      },
      {
        variant: "light",
        appearance: "warning",
        class: "bg-warning-200/50 border-warning-200/50 !text-warning"
      },
      {
        variant: "light",
        appearance: "info",
        class: "bg-info-200/50 border-info-200/50 !text-info"
      },
      {
        variant: "light",
        appearance: "background",
        class: "bg-background/20 border-background/20 !text-foreground"
      },
      {
        variant: "light",
        appearance: "foreground",
        class: "bg-foreground/20 border-foreground/20 !text-background"
      }
    ],
    defaultVariants: {
      variant: "default",
      appearance: "gray",
      size: "md"
    }
  }
), n = r("rounded-full p-0.5 transition-colors ", {
  variants: {
    appearance: {
      gray: "bg-white/20 hover:bg-white/30",
      deep: "bg-deep-1100/50 hover:bg-deep-1100/80",
      primary: "bg-primary-1100/50 hover:bg-primary-1100/80",
      secondary: "bg-secondary-1100/50 hover:bg-secondary-1100/80",
      tertiary: "bg-tertiary-1100/50 hover:bg-tertiary-1100/80",
      success: "bg-success-1100/50 hover:bg-success-1100/80",
      danger: "bg-danger-1100/50 hover:bg-danger-1100/80",
      warning: "bg-warning-1100/50 hover:bg-warning-1100/80",
      info: "bg-info-1100/50 hover:bg-info-1100/80",
      background: "bg-background/50 hover:bg-background/80",
      foreground: "bg-foreground/50 hover:bg-foreground/80"
    },
    variant: {
      default: "",
      outline: "bg-gray-700/20 hover:bg-gray-700/30",
      light: "bg-gray/20 hover:bg-gray/30 text-gray",
      icon: ""
    }
  },
  compoundVariants: [
    {
      variant: "light",
      appearance: "deep",
      class: "bg-deep/20 hover:bg-deep/30"
    },
    {
      variant: "light",
      appearance: "primary",
      class: "bg-primary/20 hover:bg-primary/30"
    },
    {
      variant: "light",
      appearance: "secondary",
      class: "bg-secondary/20 hover:bg-secondary/30"
    },
    {
      variant: "light",
      appearance: "tertiary",
      class: "bg-tertiary/20 hover:bg-tertiary/30"
    },
    {
      variant: "light",
      appearance: "success",
      class: "bg-success/20 hover:bg-success/30"
    },
    {
      variant: "light",
      appearance: "danger",
      class: "bg-danger/20 hover:bg-danger/30"
    },
    {
      variant: "light",
      appearance: "warning",
      class: "bg-warning/20 hover:bg-warning/30"
    },
    {
      variant: "light",
      appearance: "info",
      class: "bg-info/20 hover:bg-info/30"
    },
    {
      variant: "light",
      appearance: "background",
      class: "bg-background/20 hover:bg-background/30"
    },
    {
      variant: "light",
      appearance: "foreground",
      class: "bg-foreground/20 hover:bg-foreground/30"
    }
  ],
  defaultVariants: {
    variant: "default",
    appearance: "gray"
  }
});
export {
  n as pillRemoveButtonVariants,
  e as pillVariants
};
//# sourceMappingURL=Pill.styles.es.js.map
